import { QueryParams, axiosInstance } from './req';

export const getHistoryForMap = async (deviceUuid: string, { perPage }: QueryParams): Promise<any> => {
    return axiosInstance.get(`/api/history/map/${deviceUuid}`, { params: { perPage } }).then(({ data }) => data);
};

export const getDeviceHistory = async (deviceUuid: string, { page, perPage, filter }: QueryParams): Promise<any> => {
    return axiosInstance
        .get(`/api/history/find/device/${deviceUuid}`, { params: { page, perPage, filter } })
        .then(({ data }) => data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const exportHistoryCsv = async (deviceUuid: string): Promise<any> => {
    return axiosInstance.get(`/api/v2/history/${deviceUuid}/csv`);
};

export const clearDeviceHistory = async (deviceUuid: string): Promise<any> => {
    return axiosInstance.delete(`/api/v2/history/${deviceUuid}`).then(({ data }) => data);
};

export const getDevicesHistory = async (deviceUUIDs: string[]): Promise<any> => {
    return axiosInstance.post('/api/v2/history', { deviceUUIDs });
};
